<div class="filter-container" style="display: flex; gap: 1rem">
  <mat-form-field appearance="outline">
    <mat-label>{{'Search Full Name' | translate}}</mat-label>
    <input (keyup.enter)="applyFilter()" [(ngModel)]="filterFullName" matInput>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{'Search Personal ID' | translate}}</mat-label>
    <input (keyup.enter)="applyFilter()" [(ngModel)]="filterPersonalNumber" matInput>
  </mat-form-field>

  <button (click)="applyFilter()" color="primary" mat-raised-button
          style="height: 55px">{{'Apply Filter' | translate}}</button>

  <button (click)="clearFilter()" color="secondary" mat-raised-button
          style="height: 55px">{{'Clear' | translate}}</button>
</div>

<table [dataSource]="volunteers" class="mat-elevation-z8" mat-table>
  <ng-container matColumnDef="fullName">
    <th *matHeaderCellDef mat-header-cell> {{ 'Full Name' | translate }}</th>
    <td *matCellDef="let volunteer" mat-cell> {{volunteer.fullName}} </td>
  </ng-container>

  <ng-container matColumnDef="city">
    <th *matHeaderCellDef mat-header-cell> {{ 'City' | translate }}</th>
    <td *matCellDef="let volunteer" mat-cell> {{volunteer.city}} </td>
  </ng-container>

  <ng-container matColumnDef="gender">
    <th *matHeaderCellDef mat-header-cell> {{ 'Gender' | translate }}</th>
    <td *matCellDef="let volunteer" mat-cell> {{volunteer.gender}} </td>
  </ng-container>

  <ng-container matColumnDef="personalNumber">
    <th *matHeaderCellDef mat-header-cell> {{ 'Personal Number' | translate }}</th>
    <td *matCellDef="let volunteer" mat-cell> {{volunteer.personalNumber}} </td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th *matHeaderCellDef mat-header-cell> {{ 'Email' | translate }}</th>
    <td *matCellDef="let volunteer" mat-cell> {{volunteer.email}} </td>
  </ng-container>

  <ng-container matColumnDef="age">
    <th *matHeaderCellDef mat-header-cell> {{ 'Age' | translate }}</th>
    <td *matCellDef="let volunteer" mat-cell> {{volunteer.age}} </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th *matHeaderCellDef mat-header-cell> {{ 'Status' | translate }}</th>
    <td *matCellDef="let volunteer" mat-cell> {{volunteer.status}} </td>
  </ng-container>

  <ng-container matColumnDef="open">
    <th *matHeaderCellDef mat-header-cell> {{ 'Open' | translate }} </th>
    <td *matCellDef="let volunteer" mat-cell>
      <a (click)="openStatusDialog(volunteer)"
         style="cursor: pointer; color: deepskyblue; font-size: 18px; margin-left: 1rem">
        <i class="fa fa-edit"></i>
      </a>
    </td>
  </ng-container>

  <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
  <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
</table>

<mat-paginator (page)="onPageChange($event)" [length]="totalItems" [pageSize]="pageSize"></mat-paginator>
